var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationRedStorage(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.3164,
    cy: 19,
    r: 19,
    fill: "#FFE5E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7587 17.4092C28.3907 17.4092 28.0346 17.4603 27.6934 17.5503C27.7082 17.3972 27.7171 17.241 27.7171 17.0818C27.7171 14.3819 25.5539 12.1925 22.8863 12.1925C22.0584 12.1925 21.2809 12.4027 20.6014 12.7751C19.5984 10.7179 17.5124 9.30033 15.094 9.30033C11.6993 9.30033 8.94859 12.0844 8.94859 15.5201C8.94859 16.2169 9.06729 16.8866 9.27797 17.5143C7.20972 17.7816 5.61328 19.5595 5.61328 21.7219C5.61328 24.0465 7.46195 25.9355 9.75275 25.9655V25.9686L28.7587 26.0346C31.1118 26.0346 33.0198 24.1035 33.0198 21.7219C33.0198 19.3403 31.1118 17.4092 28.7587 17.4092Z",
    fill: "#F32A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5421 29.1249C13.8447 29.1249 13.2008 28.7405 12.8625 28.1218C12.5243 27.5031 12.545 26.7493 12.9159 26.1486L17.6904 18.4272C18.0435 17.8566 18.6518 17.5142 19.3195 17.5142C19.9842 17.5142 20.5925 17.8566 20.9486 18.4272L25.7201 26.1486C26.091 26.7463 26.1088 27.5031 25.7735 28.1218C25.4352 28.7405 24.7913 29.1249 24.094 29.1249H14.5421Z",
    fill: "#FFE5E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1887 18.9048L24.9632 26.6263C25.3935 27.32 24.8979 28.221 24.0908 28.221H14.5418C13.7317 28.221 13.2392 27.32 13.6694 26.6263L18.4439 18.9048C18.8475 18.2531 19.7851 18.2531 20.1887 18.9048Z",
    fill: "#E54D2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8449 19.7908L23.9725 26.4701C24.2337 26.8905 23.934 27.4371 23.4443 27.4371H15.1892C14.6995 27.4371 14.3998 26.8905 14.661 26.4701L18.7886 19.7908C19.0319 19.3943 19.6016 19.3943 19.8449 19.7908Z",
    fill: "#F32A00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2808 15.5262C12.2808 14.1507 13.3846 13.0335 14.7437 13.0335",
    stroke: "#FFE5E0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.625 14.6402C24.4499 14.6402 25.1205 15.3189 25.1205 16.1538",
    stroke: "#FFE5E0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6902 25.9596C19.6902 26.4882 18.8979 26.4882 18.8979 25.9596C18.8979 25.431 19.6902 25.431 19.6902 25.9596ZM19.625 22.0613V25.2658H18.9751C18.9751 24.1846 18.9751 23.1425 18.9751 22.0613H19.625Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationRedStorage);
export default __webpack_public_path__ + "static/media/notification_red_storage.a84dd0d3b75d63a0a65ee9d0e609487c.svg";
export { ForwardRef as ReactComponent };